import { combineReducers } from '@reduxjs/toolkit';

import { mapEntitiesReducer } from './mapEntitiesSlice';
import { stateReducer } from './stateSlice';

export const layersReducer = combineReducers({
  mapEntities: mapEntitiesReducer,
  state: stateReducer,
});
